import imgOutside from '../../assets/buildings/data-center/outside.png';
import imgWasteWater from '../../assets/buildings/data-center/waste-water.png';
import imgCooling from '../../assets/buildings/data-center/cooling.png';
import imgWater from '../../assets/buildings/data-center/water.png';
import { Building, BuildingArea, SubBuilding } from '../../interfaces/buildings';
import { ProductType } from '../products';
import { TechSector } from '../tech-sector';
import imgAirEtabloc from '../../assets/buildings/data-center/air/etabloc.png';
import imgAirEtachrom from '../../assets/buildings/data-center/air/etachrom.png';
import imgAirEtaline from '../../assets/buildings/data-center/air/etaline.png';
import imgAirEtanorm from '../../assets/buildings/data-center/air/etanorm.png';
import imgAirMovitec from '../../assets/buildings/data-center/air/movitec.webp';
import imgDirectEtaseco from '../../assets/buildings/data-center/direct/etaseco.png';
import imgDirectIll from '../../assets/buildings/data-center/direct/ill.png';
import imgDirectMagnochem from '../../assets/buildings/data-center/direct/magnochem.png';
import imgLiquidEtabloc from '../../assets/buildings/data-center/liquid/etabloc.png';
import imgLiquidEtachrom from '../../assets/buildings/data-center/liquid/etachrom.png';
import imgLiquidEtanorm from '../../assets/buildings/data-center/liquid/etanorm.png';
import imgLiquidEtaseco from '../../assets/buildings/data-center/liquid/etaseco.png';
import { BuildingType } from '../buildings';

const dataCenterConfig: BuildingArea = {
    sectorPosition: 'bottom',
    techSectors: [
        {
            type: TechSector.WASTE_WATER,
            img: imgWasteWater,
            products: [
                {
                    position: { x: 670, y: 880 },
                    type: ProductType.COMPACTA,
                },
                {
                    position: { x: 1750, y: 770 },
                    type: ProductType.AMA_DRAINER_BOX_UNTERFLUR,
                },
            ],
        },
        {
            type: TechSector.HEATING,
            img: imgCooling,
            buildings: [
                {
                    coordinates: { x: 460, y: 710 },
                    building: BuildingType.DATA_CENTER_COOLING_AIR,
                    link: `${BuildingType.DATA_CENTER_COOLING_AIR}/${TechSector.HEATING}`,
                    showSector: false,
                },
                {
                    coordinates: { x: 870, y: 400 },
                    building: BuildingType.DATA_CENTER_COOLING_DIRECT,
                    link: `${BuildingType.DATA_CENTER_COOLING_DIRECT}/${TechSector.HEATING}`,
                    showSector: false,
                },
                {
                    coordinates: { x: 1480, y: 390 },
                    building: BuildingType.DATA_CENTER_COOLING_LIQUID,
                    link: `${BuildingType.DATA_CENTER_COOLING_LIQUID}/${TechSector.HEATING}`,
                    showSector: false,
                },
            ],
        },
        {
            type: TechSector.WATER,
            img: imgWater,
            products: [
                {
                    position: { x: 845, y: 810 },
                    type: ProductType.DELTA_PRIMO_SVP,
                },
                {
                    position: { x: 1070, y: 890 },
                    type: ProductType.SISTO_16_RGAMAXX,
                },
                {
                    position: { x: 1543, y: 850 },
                    type: ProductType.SISTO_16_TWA,
                },
            ],
        },
    ],
    img: imgOutside,
};

export const dataCenterCoolingAirConfig: SubBuilding = {
    parentBuilding: BuildingType.DATA_CENTER,
    img: imgAirEtanorm,
    techSectors: [{ type: TechSector.HEATING }],
    products: [
        {
            position: { x: 200, y: 500 },
            type: ProductType.BOAX_S_SF,
        },
        {
            position: { x: 440, y: 270 },
            type: ProductType.SERIE_2000,
        },
        {
            position: { x: 1330, y: 190 },
            type: ProductType.BOA_SYSTRONIC_EPIC,
        },
    ],
    alternativeProducts: {
        position: { x: 505, y: 450 },
        alternatives: [
            {
                type: ProductType.ETANORM,
                img: imgAirEtanorm,
            },
            {
                type: ProductType.ETABLOC,
                img: imgAirEtabloc,
            },
            {
                type: ProductType.ETACHROM,
                img: imgAirEtachrom,
            },
            {
                type: ProductType.ETALINE,
                img: imgAirEtaline,
                position: { x: 490, y: 385 },
            },
            {
                type: ProductType.MOVITEC,
                img: imgAirMovitec,
                position: { x: 410, y: 440 },
            },
        ],
    },
};

export const dataCenterCoolingDirectConfig: SubBuilding = {
    parentBuilding: BuildingType.DATA_CENTER,
    img: imgDirectEtaseco,
    techSectors: [{ type: TechSector.HEATING }],
    products: [
        {
            position: { x: 495, y: 210 },
            type: ProductType.SISTO_16_RGAMAXX,
        },
        {
            position: { x: 552, y: 342 },
            type: ProductType.BOA_SYSTRONIC_EPIC,
        },
        {
            position: { x: 1490, y: 528 },
            type: ProductType.SISTO_RSK,
        },
        {
            position: { x: 1580, y: 458 },
            type: ProductType.ISORIA_10_16,
        },
    ],
    alternativeProducts: {
        position: { x: 1219, y: 858 },
        alternatives: [
            {
                type: ProductType.ETASECO,
                img: imgDirectEtaseco,
            },
            {
                type: ProductType.MAGNOCHEM,
                img: imgDirectMagnochem,
            },
            {
                type: ProductType.MAGNOCHEM_BLOC,
                img: imgDirectIll,
            },
        ],
    },
};

export const dataCenterCoolingLiquidConfig: SubBuilding = {
    parentBuilding: BuildingType.DATA_CENTER,
    img: imgLiquidEtanorm,
    techSectors: [{ type: TechSector.HEATING }],
    products: [
        {
            position: { x: 520, y: 480 },
            type: ProductType.SISTO_RSK,
        },
        {
            position: { x: 670, y: 460 },
            type: ProductType.ISORIA_10_16,
        },
        {
            position: { x: 1186, y: 450 },
            type: ProductType.BOA_SYSTRONIC_EPIC,
        },
    ],
    alternativeProducts: {
        position: { x: 370, y: 680 },
        alternatives: [
            {
                type: ProductType.ETANORM,
                img: imgLiquidEtanorm,
            },
            {
                type: ProductType.ETASECO,
                img: imgLiquidEtaseco,
            },
            {
                type: ProductType.ETABLOC,
                img: imgLiquidEtabloc,
            },
            {
                type: ProductType.ETACHROM,
                img: imgLiquidEtachrom,
            },
        ],
    },
};

export default dataCenterConfig;
